import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { User } from '../model/user';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    public currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    public userMenu: any = [];

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    public currentUserRights(path): any {
        let rights = [];
        // if (this.currentUserSubject.value.menuList.map(x => x.path).indexOf(path) !== -1) {
        //     rights = this.currentUserSubject.value.menuList.find(x => x.path === path);
        //   }
        return rights;
    }

    login(userModel: User) {

        // return this.http.post<any>(`${environment.apiUrl}/Login/Login`, userModel)
        //     .pipe(map(user => {

        //         // const userMenus = JSON.parse(user.userMenu) as UserMenu[];
        //         // userMenus.forEach((x) => {
        //         //     this.Iteratemenu(x);
        //         //   });
        //         // user.menuList = this.userMenu;

        //         this.currentUserSubject.next(user);

        //         // store user details and jwt token in local storage to keep user logged in between page refreshes
        //         localStorage.setItem('currentUser', JSON.stringify(user));
        //         return user;
        //     }));
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }

    // forgot(userModel: User) {

    //     return this.http.post<any>(`${environment.apiUrl}/Login/ForgotPassword`, userModel)
    //         .pipe(map(user => {
    //             return user.message;
    //         }));
    // }

    // reset(userModel: User) {

    //     return this.http.post<any>(`${environment.apiUrl}/Login/ResetPassword`, userModel)
    //         .pipe(map(user => {
    //             return user.message;
    //         }));
    // }

    // Iteratemenu(menu: UserMenu) {
    //     if (menu.Children.length > 0) {
    //       // tslint:disable-next-line: prefer-for-of
    //       for (let i = 0; i < menu.Children.length; i++) {
    //         this.Iteratemenu(menu.Children[i]);
    //       }
    //     } else {

    //         this.userMenu.push(
    //             {
    //                 path: menu.path,
    //                 isadd: menu.isadd,
    //                 isedit: menu.isedit,
    //                 isdelete: menu.isdelete,
    //                 isview: menu.isview
    //             });
    //     }
    //   }
}
